import { isAxiosError } from '@cast/api-client';

export const isNotFoundError = (error: unknown): boolean =>
  isAxiosError(error) && error.response?.status === 404;
